import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { LoginPage } from '../login/login';


@Component({
  selector: 'page-intro',
  templateUrl: 'intro.html',
  host: { '(document:keydown)': 'handleKeyboardEvents($event)' }
})

export class IntroPage {
  flipState: String = 'notFlipped';
  flyInOutState: String = 'in';
  fadeState: String = 'visible';
  bounceState: String = 'noBounce';
  endOfIntroDone: boolean = false;
  
  constructor(public functions: Functions,public rubedoSideMenu: MenuController, public translate: TranslateService, public navCtrl: NavController) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(false, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(false);
    this.endOfIntroDone=false;
  }

  ionViewWillEnter(){
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(false);
    if (this.functions.isRunningOnMobile() || this.functions.isRunningOnBrowser('Chrome')) {
      this.endOfIntro(0);
    }else{
      setTimeout(() => {
        this.endOfIntro(0);
      }, 7000);
    }
  }

  endOfIntro(comingFrom){
    if(!this.endOfIntroDone){
      this.endOfIntroDone=true;
      this.navCtrl.setRoot(LoginPage, {} /*, {animate: true}*/);
      this.functions.initApp();
      //this.functions.startBgMusic('app_BgMusic');
    }
  }
  
  handleKeyboardEvents(event: KeyboardEvent) { 
    if(this.navCtrl.getActive().name=="IntroPage"){
      this.endOfIntro(1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/intro/intro.ts